// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"acc020b0","356":"c862b53d","585":"39255e7e","598":"eac6aa44","703":"acc020b0","807":"4883bccd","925":"acc020b0","950":"8d0161f4"}[chunkId] + ".chunk.css";
};